import { render, staticRenderFns } from "./StoneTypeList.vue?vue&type=template&id=0067e4df&scoped=true&"
import script from "./StoneTypeList.vue?vue&type=script&lang=js&"
export * from "./StoneTypeList.vue?vue&type=script&lang=js&"
import style0 from "./StoneTypeList.vue?vue&type=style&index=0&id=0067e4df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067e4df",
  null
  
)

export default component.exports